import { render } from "./Wellnesses.vue?vue&type=template&id=040c722d&scoped=true"
import script from "./Wellnesses.vue?vue&type=script&lang=js"
export * from "./Wellnesses.vue?vue&type=script&lang=js"

import "./Wellnesses.vue?vue&type=style&index=0&id=040c722d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040c722d"]])

export default __exports__